const useStyles = () => {
    return {
        container: {
            width: '450px',
            backgroundColor: 'white',
            padding: '16px 24px',
            height:'95%'
        },
        header: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }
}

export { useStyles }